<script>

    import $ from 'jquery';
    import 'select2';
    import { http } from '../../../http';
    import isEmpty from 'lodash/isEmpty';

    export default {
        data() {
            return {
                chosenClientOrGroupId : this.value,
                chosenClientOrGroupObject : null,
                groupSelected: this.initialValueIsGroup,
                data : [],
                cursor: '',
                specificClientData: this.specific_client_data,
                language: {
                    errorLoading: function() {
                        return trans('clients.select_1')
                    },
                    loadingMore: function() {
                        return trans('clients.select_2')
                    },
                    noResults: function() {
                        return trans('clients.select_3')
                    },
                    searching: function() {
                        return trans('clients.select_4')
                    }
                }
            }
        },

        mounted(){
            this.init();
        },

        beforeUnmount() {
            $(this.$refs[this.domRef]).select2('destroy');
        },

        methods: {
            init() {
                var vm = this;

                this.$event_bus.$on('clientsSelectUpdate', (client) => {
                    // Only update if this instance has the client currently selected
                    // This is just a quick fix for the a user has MedCom active 2 instances of the component will be instantiated
                    // and the client will be selected in both instances causing an error when editing a booking.
                    if (this.chosenClientOrGroupId === client.id) {
                        this.chosenClientOrGroupId = client.id;
                    }
                });

                this.$event_bus.$on('hideMergeTile', () => {
                    this.specificClientData = [];
                    this.chosenClientOrGroupId = null;
                    this.buildSelectList();
                });

                if (!isEmpty(this.specificClientData)) {

                    this.$nextTick( () => {

                        $(this.$refs[this.domRef]).select2({
                            theme: "bootstrap",
                            dropdownParent: $(`#${this.id}`),
                            language: this.language,
                            placeholder: this.placeholder,
                            data: this.specificClientData
                        }).on('select2:select', function (e) {
                            vm.chosenClientOrGroupId = e.params.data.id;
                        });
                    });

                    this.chosenClientOrGroupId = this.value;

                } else {
                    this.$nextTick( () => {
                        this.buildSelectList(vm);
                        this.chosenClientOrGroupId = this.value;
                    });
                }

                if (!isEmpty(this.specificClientData)) {
                    this.chosenClientOrGroupId = this.specificClientData[0].id;
                }

                if (this.autoFocus) {
                    this.focusSelect();
                }
            },
            buildSelectList(vm) {
                $(this.$refs[this.domRef]).select2({
                    theme: "bootstrap",
                    dropdownParent: $(`#${this.id}`),
                    language: this.language,
                    placeholder: this.placeholder,
                    minimumResultsForSearch: 10,
                    ajax: {
                        url: '/app/clients/get/select',
                        delay: 250, // wait 250 milliseconds before triggering the request
                        dataType: 'json',
                        data: (params) => {
                            // The cursor needs to be reset every time the user changes the search term
                            // select2 doesn't provide a way of setting a callback for this, so we rely on the fact
                            // that the page parameter gets reset to undefined when the user types something new
                            if (!params.page) {
                                vm.cursor = '';
                            }

                            const query = {
                                search: params.term,
                                cursor: vm.cursor,
                            }

                            if (this.payerId) {
                                query.payer_id = this.payerId;
                            }

                            if (this.payers) {
                                query.payers = true

                                if (this.payerType) {
                                    query.payerType = this.payerType;
                                }
                            }

                            if (this.include_email) {
                                query.include_email = true;
                            }

                            if (this.groups) {
                                query.client_groups = this.groups;
                            }

                            return query
                        },
                        processResults: (data) => {
                            vm.cursor = data.pagination.cursor;

                            return data;
                        },
                    },
                }).on('select2:select', function (e) {
                    vm.groupSelected = e.params.data.group;

                    // If the user selected an option its because he can view it so we can remove the blur
                    $(`.create-client-booking #${vm.id} .select2-selection__rendered`).css('filter', '')
                    vm.chosenClientOrGroupId = e.params.data.id;
                });
            },

            setSelectedValue(id){
                if(!id) {
                    $(this.$refs[this.domRef]).val(0).trigger('change');
                    return false;
                }

                let url;
                if (this.payers) {
                    url = `/app/payers/${id}`;
                } else if (this.groupSelected){
                    url = `/app/clients/groups/${id}`;
                } else {
                    url = `/app/client/${id}?json`;
                }

                // Set the value, creating a new option if necessary
                http.get(url)
                    .then(({ data }) => {

                        const canSeeClientInfo = this.$can('see-client', data) || this.can_see_unassigned_client_names
                        this.chosenClientOrGroupObject = {
                            ...data,
                            name: canSeeClientInfo
                                ? data.name
                                : trans('clients.unknown_client')
                        }

                        if (isEmpty(this.specificClientData)) {
                            // Create a DOM Option and pre-select by default
                            var newOption = this.include_email && !this.groupSelected && this.chosenClientOrGroupObject.email
                                ? new Option(`${this.chosenClientOrGroupObject.name} (${this.chosenClientOrGroupObject.email})`, id, true, true)
                                : new Option(this.chosenClientOrGroupObject.name, id, true, true);

                            if (!canSeeClientInfo) {
                                $(`.create-client-booking #${this.id} .select2-selection__rendered`).css('filter', 'blur(3px)')
                            }
                            // Append it to the select
                            $(this.$refs[this.domRef]).append(newOption).trigger('change');
                        } else {
                            $(`#${this.id} option[value="0"]`).remove();
                        }
                    })
                    .catch(() => {});
            },

            focusSelect() {
                this.$nextTick(() => {
                    this.$refs[this.domRef].focus();
                });
            },

	        clearSelection() {
		        this.chosenClientOrGroupId = null;
	        },
        },

        props: {
            value: {
                default: null,
            },
            visible: {
                type: Boolean,
                default: false,
                required: false,
            },
            initialValueIsGroup: {
                type: Boolean,
                default: false,
                required: false,
            },
            id: {
                required: false,
                default: 'clients-select-new'
            },
            specific_client_data: {
                required: false,
                default: null
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
            placeholder: {
                type: String,
                required: false,
                default: trans('calendar.create_client_label_choose_client'),
            },
            payers: {
                type: Boolean,
                required: false,
                default: () => false,
            },
            payerType: {
                type: String,
                required: false,
                default: null,
            },
            payerId: {
                type: Number,
                required: false,
                default: null,
            },
            groups: {
                type: Boolean,
                required: false,
                default: false,
            },
            client_dropdown_search_value: {
                default: null
            },
            include_email: {
                type: Boolean,
                required: false,
                default: false,
            },
            autoFocus: {
                type: Boolean,
                default: false,
                required: false
            },
            domRef: {
                type: String,
                default: 'clients_select'
            }
        },

        computed: {
            can_see_unassigned_client_names() {
                return this.$store.state.auth.user ? this.$store.state.auth.user.can_see_unassigned_client_names : false
            }
        },

        watch: {
            value(val) {
                this.chosenClientOrGroupId = val;
            },
            initialValueIsGroup(value) {
                this.groupSelected = value;
            },
            visible(value) {
                if(value) {
                    this.init();
                    return;
                }
                $(this.$refs[this.domRef]).select2('destroy');
            },
            chosenClientOrGroupId: {
                handler(value) {
                    this.$emit('input', value);
                    this.setSelectedValue(value);
                },
                immediate: true,
            },
            chosenClientOrGroupObject(value) {
                this.$emit('clientSelected', value);
            },
            client_dropdown_search_value(newValue) {
                if (newValue) {
                    $(this.$refs[this.domRef]).select2('open'); // the first keydown opens the dropdown
                    $('.select2-search__field').val(newValue); // the same keydown event also takes the value and changes the input in dom directly.
                    this.$emit('resetAutoSelectClient') // as soon as the first character is placed in input, the event-listener is removed.
                }
            }
        }
    };
</script>

<template>
    <div :id="id" class="client-select-new">
        <select class="form-control" name="client" :ref="domRef" style="width: 100%;" :disabled="disabled">
            <option :value="null">{{ placeholder }}</option>
        </select>

	    <a class="clear-filters" v-show="value" @click.prevent="clearSelection" href="#">
		    <i class="zmdi zmdi-close"></i>
	    </a>
    </div>
</template>

<style lang="scss" scoped>
 .client-select-new {
	 position: relative;
	 a.clear-filters {
        position: absolute;
        right: 1px;
        top: 1px;
        padding: 7px 15px 8px;
        background: var(--n-color-background);
        color: var(--n-color-text-weak);
        border-bottom-right-radius: 4px;
        border-top-right-radius: 4px;
        border-left: 1px solid var(--n-color-border);
	 }
 }
</style>
